/* eslint-disable react/no-array-index-key */

import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ProductListResultViewModel } from 'autogen/swagger/all';
import { ShowFilters } from 'autogen/translation-keys/trans-website-filter';
import FilterMenuDrawer from '../../FilterMenu/FilterMenuDrawer';
import RootFilterMenuItemRenderer from './RootFilterMenuItemRenderer';

export const rootMenuId = 'filter-root-menu';

const RootFilterMenu = ({
    filters,
    activeFilterValues
}: {
    filters: ProductListResultViewModel['filters'];
    activeFilterValues: ProductListResultViewModel['activeFilterValues'];
}) => {
    const { t } = useTranslation();

    const memoizedMenuStructure = useMemo(
        () => (
            <>
                {filters.map((filter, index) => (
                    <RootFilterMenuItemRenderer key={index} model={filter} />
                ))}
            </>
        ),
        [filters]
    );

    return (
        <FilterMenuDrawer
            id={rootMenuId}
            animate
            headline={activeFilterValues.length ? `${t(ShowFilters)} (${activeFilterValues.length})` : t(ShowFilters)}
            withDividers
        >
            {memoizedMenuStructure}
        </FilterMenuDrawer>
    );
};

export default memo(RootFilterMenu);
